import { ColumnSort, SortingState } from '@tanstack/react-table'
import { useEffect, useState } from 'react'
import { KeyAsString } from 'type-fest'

import { dashed } from 'utils/string'
import { SortInputKey, SortProps, UseTableSort } from './types'

const inputToSortingState = <T>(input?: SortInputKey<T>) => {
  const { by, direction } = input || {}

  return by ? [{ desc: direction === 'desc', id: by }] : []
}

export const useTableSort = <T>(sort?: SortProps<T>): UseTableSort => {
  const [sorting, setSorting] = useState<SortingState>(() => {
    if (!sort?.input) {
      return []
    }

    return inputToSortingState<T>({
      ...sort.input,
      by: dashed(sort.input.by) as KeyAsString<T>,
    })
  })

  useEffect(() => {
    if (!sort || sorting.length === 0) {
      return
    }

    const { desc, id }: ColumnSort = sorting[0]

    sort.onSort({
      by: id as KeyAsString<T>,
      direction: desc ? 'desc' : 'asc',
    })
  }, [sorting])

  return { setSorting, sorting }
}
